module.exports = __webpack_public_path__ + "img/HC1028-76.72e3eac0.jpg";